// @core/api/endpoints/webhook/get_delivery.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeliveryResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Get delivery details
 * Retrieves complete details of a specific webhook delivery including the request payload, response, and retry attempts.
 */
export async function GetDelivery(
  endpoint_id: string,
  delivery_id: string,
  options?: RequestOptions
): Promise<DeliveryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/deliveries/:delivery_id`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  requestPath = requestPath.replace(':delivery_id', encodeURIComponent(delivery_id));
  const requestOptions = options;
  return client.get<DeliveryResponse>(requestPath, { ...requestOptions });
}
